// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { VERSION } from "./lib/utils/version.js";
import { parseWKT, isWKT, WKT_MAGIC_STRINGS } from "./lib/parse-wkt.js";
/**
 * Well-Known text worker loader
 */
export const WKTWorkerLoader = {
    dataType: null,
    batchType: null,
    name: 'WKT (Well-Known Text)',
    id: 'wkt',
    module: 'wkt',
    version: VERSION,
    worker: true,
    extensions: ['wkt'],
    mimeTypes: ['text/plain'],
    category: 'geometry',
    text: true,
    tests: WKT_MAGIC_STRINGS,
    testText: isWKT,
    options: {
        wkt: {
            shape: 'geojson-geometry',
            crs: true
        }
    }
};
/**
 * Well-Known text loader
 */
export const WKTLoader = {
    ...WKTWorkerLoader,
    parse: async (arrayBuffer, options) => parseWKT(new TextDecoder().decode(arrayBuffer), options),
    parseTextSync: (string, options) => parseWKT(string, options)
};
